<template>
    <div class="reports-page-container">
        <div class="reports-header">
            <h2 class="page-title">
                <i class="material-icons title-icon">assessment</i>
                <strong>Reports Dashboard</strong>
            </h2>
            <p class="page-subtitle">Generate comprehensive reports and insights for your business</p>
        </div>
        
        <div class="reports-navigation">
            <ReportSidebar />
        </div>
        
        <div class="reports-content">
            <div class="content-wrapper">
                <router-view />
            </div>
        </div>
    </div>
</template>

<script>
import CrudIndex from "../../components/crud/index.vue"
import { createField, createColumn } from "../../utils/common"
import { http } from "@/utils/http"
import Paginator from "../../components/other/Paginator.vue"
import Card from "../../components/UI/Card.vue"
import ReportSidebar from "../../components/reports/sidebar/ReportSidebar.vue"

export default {
    data() {
        return {}
    },
    components: { CrudIndex, Paginator, Card, ReportSidebar },
    async mounted() {},
    methods: {},
}
</script>

<style lang="scss" scoped>
@import "../../assets/variables.scss";

.reports-page-container {
    background-color: $backgroundColor;
    min-height: 100vh;
    padding: $cardPaddingY $cardPaddingX;
}

.reports-header {
    margin-bottom: $sectionGap;
    
    .page-title {
        display: flex;
        align-items: center;
        gap: $sectionGap;
        font-size: 28px;
        font-weight: 700;
        color: $primaryColor;
        margin: 0 0 8px 0;
        letter-spacing: -0.02em;
        
        .title-icon {
            font-size: 32px;
            color: $secondaryColor;
        }
    }
    
    .page-subtitle {
        font-size: 16px;
        color: rgba($textColor, 0.7);
        margin: 0;
        margin-left: 44px;
    }
}

.reports-navigation {
    margin-bottom: $sectionGap;
}

.reports-content {
    .content-wrapper {
        background: $lightCardBg;
        border-radius: 16px;
        box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06);
        border: 1px solid $lightBorderColor;
        overflow: hidden;
        min-height: 600px;
    }
}

/* Responsive Design */
@media (max-width: 768px) {
    .reports-page-container {
        padding: 16px;
    }
    
    .reports-header {
        margin-bottom: 20px;
        
        .page-title {
            font-size: 24px;
            
            .title-icon {
                font-size: 28px;
            }
        }
        
        .page-subtitle {
            font-size: 14px;
            margin-left: 40px;
        }
    }
    
    .reports-navigation {
        margin-bottom: 20px;
    }
}

/* Dark theme support (app-level .dark class) */
.dark .reports-page-container { background-color: $backgroundColorDark; }
.dark .reports-header .page-title { color: $darkTextColor; }
.dark .reports-header .page-subtitle { color: rgba($darkTextColor, 0.7); }
.dark .reports-content .content-wrapper { background: $darkCardBg; border-color: $darkBorderColor; }
</style>
